<template>
  <div>
    <nav
      @focusout="isActive = false"
      tabindex="-1"
      class="navbar is-dark is-fixed-top is-vcentered is-blue-bar "
      :class="[isCentered ? ' display-center' : '']"
      role="navigation"
      aria-label="main navigation"
      style="justify-content: space-between; height: 30px;"
    >
      <div class="navbar-brand bar-relative-position">
        <RouterLink
          class="navbar-item menu-golstats"
          :to="{
            path:
              getUserType == 0
                ? !isWidgetUrl
                  ? '/bets'
                  : '/widget/' + isWidgetUrlTeam
                : $route.name === 'activeTime'
                ? getUserType == 0
                  ? '/bets'
                  : '/landing'
                : '/landing',
          }"
        >
          <img src="/images/logotodoelfut.png" alt="GolStats Logo" />
        </RouterLink>
      </div>

      <template>
        <div id="current-items" class="navbar-menu bar-relative-position">
          <div class="navbar-end">
            <div class="options" v-if="getUserType == 0 && !getPremiumAccount">
              <a class="options__create-account " @click="onClickLogin">
                Iniciar Sesión
              </a>
              <a @click="onClickRegister">Crear Cuenta</a>
            </div>
          </div>
        </div>
      </template>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { clickLogin, clickCrearCuentaPremium } from '@/utils/analytics';
export default {
  components: {},
  props: {
    showMenuItems: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      inputActiveFocus: false,
      viewnum: 0,
    };
  },
  computed: {
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'getUserType']),
    isWidgetUrl() {
      var isG = false;
      if (window.sessionStorage.getItem('IsWidget') !== null) {
        isG = true;
      }
      return isG;
    },
    isWidgetUrlTeam() {
      return window.sessionStorage.getItem('WidgetTeam');
    },
    isCentered() {
      return this.$route.name === 'gs' ? true : false;
    },
  },
  methods: {
    ...mapMutations(['SET_AUTH_COMPONENT']),
    ...mapActions('loginGeneral', ['deleteUserInfo']),
    onClickRegister() {
      clickCrearCuentaPremium({
        is_premium: this.getPremiumAccount,
        golstats: this.getUserType,
        section: 'menu_lateral',
        banner: 'Banner_Home_Widget',
      });
      this.SET_AUTH_COMPONENT('SelectPlan');
    },
    onClickLogin() {
      clickLogin({ is_premium: this.getPremiumAccount, section: 'menu_lateral', golstats: this.getIsGolstats });
      this.SET_AUTH_COMPONENT('LoginMain');
    },
    goTo(route) {
      this.$router.push(route);
      this.isActive = false;
    },
    logout() {
      this.$store.commit('mediaGeneral/setUserPlaylists', []);
      this.$store.commit('teamsGeneral/updateTeams', []);
      this.$store.commit('loginGeneral/setSeasonsSelected', null);
      this.deleteUserInfo();
      if (window.sessionStorage.getItem('IsWidget') === null) {
        window.location.replace('/bets');
      } else {
        window.location.replace('/widget/' + window.sessionStorage.getItem('WidgetTeam'));
      }
    },
  },
};
</script>
<style scoped lang="scss">
.options {
  display: flex;
  position: relative;
  margin-right: 39px;
  & a {
    width: 150px;
    height: 39px;
    margin: 0 11px;
    line-height: 34px;
    color: white;
    font-size: 16px;
    font-family: 'Lato', sans-serif;
    border-radius: 26px;
    border: solid 1px #ffffff;
    &:hover {
      background: #cbee6b;
      border: solid 0.9px #cbee6b;
      color: #14213d;
    }
  }
  & a:last-child {
    margin-right: 0px !important;
  }
}
.bar-relative-position {
  position: relative !important;
  margin-left: 24px;
  @media screen and (max-width: 1024px) {
    justify-content: space-between !important;
  }
}
.navbar-item {
  text-transform: uppercase;
}
.display-center {
  justify-content: center;
}
nav.navbar {
  align-items: center;
}
.navbar-item.push-right {
  margin-left: auto;
}
@media screen and (min-width: 1024px) {
  .navbar {
    min-height: 4.5rem;
  }
  .navbar-item img {
    min-height: 2.5rem;
  }
}
</style>
<style lang="scss">
.dialog.modal.is-active .modal-card-foot button {
  text-transform: capitalize;
}
.is-blue-bar {
  background: #132739 !important;
  & .navbar-item:hover {
    background-color: #132739 !important;
  }
}
</style>
